export default __webpack_public_path__ + "static/media/komcare.58d1d967.svg";